import { slicedToArray as _slicedToArray, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useRef, useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import ModalContent from '../Modal/ModalContent.js';

var propTypes = {
  children: PropTypes.node.isRequired,
  direction: PropTypes.oneOf(['from-bottom', 'from-left', 'from-right', 'from-top']).isRequired,
  id: PropTypes.string.isRequired,
  classList: PropTypes.string,
  closeButtonLabel: PropTypes.string,
  closeButtonTheme: PropTypes.oneOf(['', 'inverse']),
  footer: PropTypes.node,
  heading: PropTypes.node,
  isFullBleed: PropTypes.bool,
  isFullscreen: PropTypes.bool,
  isOpen: PropTypes.bool,
  isSticky: PropTypes.bool,
  isToaster: PropTypes.bool,
  onClose: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onOpen: PropTypes.func,
  onUnmount: PropTypes.func,
  style: PropTypes.objectOf(PropTypes.string),
  variant: PropTypes.oneOf(['', 'headerless'])
};
function Toaster(props) {
  var children = props.children,
    direction = props.direction,
    isOpen = props.isOpen,
    _props$onOpen = props.onOpen,
    onOpen = _props$onOpen === void 0 ? function () {
      return undefined;
    } : _props$onOpen,
    _props$onUnmount = props.onUnmount,
    onUnmount = _props$onUnmount === void 0 ? function () {
      return undefined;
    } : _props$onUnmount;
  var toasterRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMounted = _useState2[0],
    setIsMounted = _useState2[1];
  var onAnimationEnd = useCallback(function () {
    setIsMounted(false);
    onUnmount();
  }, [onUnmount]);
  var handleOpen = useCallback(function () {
    var _toasterRef$current;
    (_toasterRef$current = toasterRef.current) === null || _toasterRef$current === void 0 || _toasterRef$current.classList.add('toaster-in');
  }, [toasterRef]);
  var handleClose = useCallback(function () {
    var _toasterRef$current2, _toasterRef$current3;
    (_toasterRef$current2 = toasterRef.current) === null || _toasterRef$current2 === void 0 || _toasterRef$current2.classList.remove('toaster-in');
    (_toasterRef$current3 = toasterRef.current) === null || _toasterRef$current3 === void 0 || _toasterRef$current3.classList.add('toaster-out');
  }, [toasterRef]);
  useEffect(function () {
    if (isOpen) setIsMounted(true);
  }, [isOpen]);
  useEffect(function () {
    if (isMounted) handleOpen();
  }, [isMounted, handleOpen]);
  useEffect(function () {
    if (!isOpen && isMounted) handleClose();
  }, [isOpen, isMounted, handleClose]);
  useEffect(function () {
    var _toasterRef$current4;
    var modalBlock = (_toasterRef$current4 = toasterRef.current) === null || _toasterRef$current4 === void 0 ? void 0 : _toasterRef$current4.querySelector('.modal-block');
    if (!isOpen && isMounted) modalBlock === null || modalBlock === void 0 || modalBlock.addEventListener('animationend', onAnimationEnd);
    return function () {
      return modalBlock === null || modalBlock === void 0 ? void 0 : modalBlock.removeEventListener('animationend', onAnimationEnd);
    };
  }, [isOpen, isMounted, onAnimationEnd]);
  if (!isMounted) return null;
  return /*#__PURE__*/createPortal(/*#__PURE__*/React__default.createElement("div", {
    className: "toaster react-toaster",
    tabIndex: "-1",
    "data-direction": direction,
    "aria-hidden": !isMounted,
    ref: toasterRef
  }, /*#__PURE__*/React__default.createElement(ModalContent, _extends({}, props, {
    isOpen: isMounted,
    isToaster: true,
    onOpen: onOpen
  }), children)), document.body);
}
Toaster.propTypes = propTypes;

export { Toaster as default };
//# sourceMappingURL=Toaster.js.map
